// Building blocks shared by the inspectors (models, code map).
import { ChevronRight, FileCode2 } from 'lucide-react';
import { useState } from 'react';
import { cn } from '../lib/cn';
import { openSourceFile } from '../state/dock';

export function Section({ title, children, defaultOpen = true, count }: { title: string; children: React.ReactNode; defaultOpen?: boolean; count?: number }) {
  const [open, setOpen] = useState(defaultOpen);
  return (
    <section className="border-b border-border">
      <button onClick={() => setOpen(!open)} className="flex h-8 w-full items-center gap-1 px-3 text-[11px] font-semibold tracking-wider text-faint uppercase hover:text-muted" aria-expanded={open}>
        <ChevronRight size={12} className={cn('transition-transform', open && 'rotate-90')} />
        {title}
        {count !== undefined && <span className="ml-auto font-normal tracking-normal normal-case">{count}</span>}
      </button>
      {open && <div className="px-3 pb-3">{children}</div>}
    </section>
  );
}

export function Field({ label, children }: { label: string; children: React.ReactNode }) {
  return (
    <div className="flex gap-3 py-0.5 text-[12.5px]">
      <span className="w-28 flex-none text-muted">{label}</span>
      <span className="min-w-0 flex-1 break-words">{children}</span>
    </div>
  );
}

export function Mono({ children }: { children: React.ReactNode }) {
  return <code className="font-mono text-[11.5px]">{children}</code>;
}

export function SourceLink({ file, line }: { file: string; line: number | undefined }) {
  return (
    <button onClick={() => openSourceFile(file, line)} className="flex items-center gap-1.5 text-[12px] text-accent hover:underline">
      <FileCode2 size={13} /> {file.slice(file.lastIndexOf('/') + 1)}
      {line !== undefined && `:${line}`}
    </button>
  );
}
